import { createContext, useContext } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { TranslationProviderProps, TranslationFunction } from './types/propsType';

const TranslationContext = createContext<TranslationFunction>(() => '');

function getTranslatedMessage(
  intl: IntlShape,
  str: string,
  values?: Record<string, string>,
  fallbackMessages?: Record<string, string>,
) {
  const message = intl.formatMessage({ id: str, defaultMessage: str }, values);
  if (message === str && fallbackMessages) {
    const enUsMessage = fallbackMessages[str];
    if (enUsMessage) {
      return enUsMessage;
    }
  }

  return message;
}

const TranslationProvider = ({
  children,
  fallbackMessages,
  translationFunction,
}: TranslationProviderProps): JSX.Element => {
  const intl = useIntl();
  const defaultFunction = (str: string, values?: Record<string, string>) =>
    getTranslatedMessage(intl, str, values, fallbackMessages);

  return (
    <TranslationContext.Provider value={translationFunction || defaultFunction}>
      <>{children}</>
    </TranslationContext.Provider>
  );
};

const useTranslation = () => {
  const translationFn = useContext(TranslationContext);
  return translationFn;
};

const useMasterdataTranslation = (masterDataName: string) => {
  const translationFn = useContext(TranslationContext);
  const masterDataAppend: TranslationFunction = (str, values) => translationFn(`${masterDataName}.${str}`, values);
  return masterDataAppend;
};

export { useTranslation, useMasterdataTranslation, TranslationProvider };
